import React from 'react';

import { variablesJSData } from 'data/javascript/variables';

import DescriptionEntry from 'components/shared/description-entry';

const ConstExample = () => {
  const item = variablesJSData?.items.find(
    (item) => item.title === 'Variables - const'
  );

  return <DescriptionEntry entry={item} />;
};

export default ConstExample;
